export const getAdjustedEventDate = (
  eventDate,
  createdAtDate,
  eventObject,
  card
) => {
  const event = new Date(eventDate); // Convert input to a Date object
  const currentDate = new Date(); // Get the current date
  // Case 1: If the event is marked as "completed" or "printed", freeze the date
  if (
    (card?.status === "completed" || card?.status === "printed") &&
    event < currentDate
  ) {
    // If `card.frozenDate` exists, return it (preserved date when the status changed)
    if (card?.frozenDate) {
      return new Date(card.frozenDate); // Preserve the previously frozen date
    } else {
      // Freeze the current adjusted date for future reference
      card.frozenDate = event.toISOString(); // Save the adjusted date
      return event;
    }
  }

  // Case 2: Handle current month events
  if (
    event.getFullYear() === currentDate.getFullYear() &&
    event.getMonth() === currentDate.getMonth()
  ) {
    return event; // Keep current month events
  }

  // Case 3: If the event is in the past year, adjust it to the current or next year
  if (event.getFullYear() < currentDate.getFullYear()) {
    event.setFullYear(currentDate.getFullYear());
    if (event < currentDate) {
      event.setFullYear(currentDate.getFullYear() + 1);
    }
    return event;
  }

  // Case 4: If the event is this year but in the past (before current date), adjust to next year
  if (
    event.getFullYear() === currentDate.getFullYear() &&
    event < currentDate
  ) {
    event.setFullYear(currentDate.getFullYear() + 1);
    return event;
  }

  // Case 5: Handle leap years for February 29th
  if (event.getMonth() === 1 && event.getDate() === 29) {
    const nextLeapYear = findNextLeapYear(currentDate.getFullYear());
    event.setFullYear(nextLeapYear);
    return event;
  }

  // Case 6: For future events, leave them unchanged
  return event;
};

// Utility function to find the next leap year
const findNextLeapYear = (year) => {
  while (true) {
    year++;
    if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
      return year;
    }
  }
};